export const reviews = [
  {
    id: 1,
    name: 'María G.',
    role: 'Homeowner',
    rating: 5,
    text: 'Excellent cleaning service, very professional and detailed. My house has never looked this good!',
    avatar: 'MG',
  },
  {
    id: 2,
    name: 'James R.',
    role: 'Property Manager',
    rating: 5,
    text: 'They helped us after construction and left everything spotless. The team was efficient and thorough.',
    avatar: 'JR',
  },
  {
    id: 3,
    name: 'Linda K.',
    role: 'Recurring Client',
    rating: 5,
    text: 'Reliable team for our recurring home cleaning. Always on time, always thorough. Highly recommended!',
    avatar: 'LK',
  },
  {
    id: 4,
    name: 'David P.',
    role: 'Business Owner',
    rating: 4,
    text: 'Great office cleaning service. Our employees notice the difference. Professional and courteous staff.',
    avatar: 'DP',
  },
];